import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ICompanyOptionResource, IContactOptionResource } from "../../../shared/types";

const getKey = (applicationId: Id, tenantId: Id) => [
	"dashboard",
	"test-drives",
	"applications",
	`${applicationId}`,
	"tenants",
	`${tenantId}`,
];

type ITestDriveType =
	| "TestDefault"
	| "TestDynamic"
	| "TestPremium"
	| "TestLongTerm"
	| "InternalTestDrive"
	| "ExternalTestDrive"
	| "PhotoShooting";

type ITestDriveStatus =
	| "draft"
	| "inReview"
	| "approved"
	| "declined"
	| "confirmed"
	| "inPreparation"
	| "preparationCompleted"
	| "readyForPickUp"
	| "inDelivery"
	| "inAssignment"
	| "inReturn"
	| "returned"
	| "assignmentEnded"
	| "archived";

export interface ICurrentAndUpcomingTestDriveResource {
	id: Id;
	status: ITestDriveStatus;
	type: ITestDriveType;
	start: string;
	end: string;
	contact: IContactOptionResource | null;
	company: ICompanyOptionResource | null;
	licensePlate: string;
	model: string;
}

export interface CurrentAndUpcomingTestDrivesWidgetData {
	total: number;
	testDrives: ICurrentAndUpcomingTestDriveResource[];
}
export const currentAndUpcomingTestDrivesWidgetService = {
	get: (applicationId: Id, tenantId: Id) => {
		return axios.get<LaravelResponse<CurrentAndUpcomingTestDrivesWidgetData>>(
			`${keyToUrl(getKey(applicationId, tenantId))}`,
		);
	},
	getKey,
};
